<template>
  <v-container grid-list-md v-if="this.$store.getters.programsFetched">
    <v-layout row wrap :class="{ white: applications.length > 0 }" v-show="!loading">
      <v-flex xs12 v-if="applications.length > 0">
        <h1 class="text-xs-center">{{ $t('message.applicationList') }}</h1>
      </v-flex>
      <v-flex xs12 class="text-xs-right">
        <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="48%">
          <v-btn
            slot="activator"
            outline
            v-show="applications.length > 0"
            class="primary-icon"
          >{{ $t('message.startNewApplication') }}</v-btn>
          <v-form ref="newAppForm" v-model="valid" @keydown="errors.clear($event.target.name)">
            <v-card>
              <v-card-title class="headline">
                <span class="headline">{{ $t('message.newApplication') }}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="intro">
                        <p>
                          Once you begin your application,
                          <b>you will have 30 days to complete it.</b>
                        </p>
                        <p>
                          If you have not completed the application after 30
                          days, your application and all data will be erased.
                        </p>
                        <p>
                          You will be able to save and resume as many times as
                          necessary within that time period.
                        </p>
                        <ul>
                          <li>
                            <b>Complete all tabs of the dealer application.</b>
                            You will not be able to submit your application
                            until all required fields have been captured.
                          </li>
                          <li>
                            <v-flex v-if="this.$store.getters.isACHRequired">
                              You will also be required to upload
                              <b>proof of business entity</b>
                              and a copy of a <b>voided check for ACH funding.</b>
                            </v-flex>
                            <v-flex v-else>
                              You will also be required to upload
                              <b>proof of business entity.</b>
                            </v-flex>
                          </li>
                        </ul>
                        <p v-if="this.$store.getters.isTDComplete">
                          If you have any questions or concerns about this
                          application, please call the Support Line at (866)
                          985-8237 for assistance.
                        </p>
                        <p v-if="!this.$store.getters.isTDComplete">
                          If you have any questions or concerns about this
                          application, please call the TDRCS Merchant Services
                          Department at (800) 538-3638 for assistance.
                        </p>
                        <p>
                          To begin, enter your legal business name and d/b/a
                          then click
                          <b>GET STARTED</b>.
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs8 sm4 offset-xs2>
                      <v-text-field
                        v-model="dealerName"
                        maxlength="40"
                        :counter="40"
                        :label="$t('message.dealerName')"
                        v-validate="'required'"
                        :error-messages="errors.collect('name')"
                        name="name"
                        data-vv-as=" "
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8 sm4>
                      <v-text-field
                        v-model="doingBusinessAs"
                        maxlength="40"
                        :counter="40"
                        :label="$t('message.dba')"
                        v-validate="'required'"
                        :error-messages="errors.collect('doingBusinessAs')"
                        name="doingBusinessAs"
                        data-vv-as=" "
                        validate-on-blur
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat class="btn-secondary" @click.native="close">{{ $t('message.cancel') }}</v-btn>
                <v-btn
                  block
                  class="btn-primary"
                  @click="create()"
                  :disabled="this.actionButtonDisabled()"
                >{{ $t('message.start') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-flex>
      <v-container grid-list-md v-if="applications.length > 0">
        <v-data-table :headers="headers" :items="applications" hide-actions class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="remove-padding">
              <v-tooltip bottom>
                <v-btn
                  class="btn-primary"
                  slot="activator"
                  @click="selectApplication(props.item.id, false)"
                >
                  <img src="static/icons/arrow_upward_white.png" width="24" />
                  {{ $t('message.resume') }}
                </v-btn>
                <span>{{ $t('message.resume') }}</span>
              </v-tooltip>
            </td>
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.name }}</td>
            <td class="hidden-sm-and-down">{{ formatDate(props.item.lastUpdateDate) }}</td>
            <td>{{ formatDate(props.item.expirationDate) }}</td>
            <td>
              <span>
                 {{ $t('message.dealerApplicationStatuses.' + props.item.status) }}
              </span>
            </td>
            <td>
                <!-- provider statuses if we have them -->
                <div v-for="lender in props.item.lenders">
                  <span v-if="lender.lenderStatus">
                    {{lender.name}} - {{ lender.lenderStatus}}
                  </span>
                </div>
            </td>
            <td class="text-xs-right">
              <v-tooltip bottom>
                <v-btn
                  dark
                  slot="activator"
                  @click="deleteApp(props.item)"
                  icon
                  class="grey--text"
                  v-if="props.item.status == 0"
                >
                  <img src="static/icons/delete_gray.png" width="26" />
                </v-btn>
                <span>{{ $t('message.remove') }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-container>
      <v-container grid-list-md v-if="applications && applications.length == 0">
        <v-layout align-center>
          <v-container fluid>
            <v-layout>
              <v-flex xs16 sm8 offset-sm2>
                <v-card>
                  <v-card-title xs11>
                    <div>
                      <h1 class="block-header">{{ $t('message.welcome') }}</h1>
                      <v-divider></v-divider>
                      <p
                        class="block-message"
                        v-html="
                          $t('message.welcomeMessage', {
                            programName: this.$store.getters.getProgramDisplayName
                          })
                        "
                      ></p>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-flex xs8 sm4 offset-sm4 class="button-buffer">
                      <v-btn block class="btn-primary" @click="dialog = true">Start Now</v-btn>
                    </v-flex>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout row wrap class="white" v-show="loading">
      <v-flex xs24 sm12>
        <h1 class="text-xs-center" style="padding-bottom: 50px;">{{ $t('message.applicationList') }}</h1>
      </v-flex>
      <v-flex xs24 sm12 style="padding-bottom: 50px;">
        <v-progress-circular
          style="width: 100%;"
          :size="70"
          :width="8"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-layout justify-center>{{ $t('message.supportNumberMsg') }}</v-layout>
  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../main.js'
import { APP_STATUSES } from '../main.js'
import axiosMixin from '@/mixins/axiosMethods'

export default {
  data: () => ({
    loading: true,
    dialog: false,
    valid: true,
    applications: [],
    authenticatedUser: null,
    headers: [
      {
        value: 'resume',
        sortable: false
      },
      {
        text: 'Id',
        align: 'left',
        value: 'id',
        width: '5%',
        sortable: false
      },
      {
        text: 'Business Name',
        align: 'left',
        value: 'name',
        sortable: false
      },
      {
        text: 'Last Edit Date',
        value: 'lastEditDate',
        class: 'hidden-sm-and-down',
        sortable: false
      },
      {
        text: 'Expiration Date',
        value: 'expirationDate',
        sortable: false
      },
      {
        text: 'Status',
        value: 'status',
        sortable: false
      },
      {
        text: 'Provider Status',
        sortable: false,
        width: '25%'
      },
      {
        value: 'delete',
        sortable: false
      }
    ],
    dealerName: '',
    doingBusinessAs: ''
  }),
  mixins: [axiosMixin],
  methods: {
    actionButtonDisabled() {
      return !this.dealerName || !this.doingBusinessAs
    },
    selectApplication(inApplicationId, isNew) {
      this.$store.commit('setApplicationId', inApplicationId)
      this.$store.commit('setApplicationJustCreated', isNew)
      this.fetchAppAndRoute(inApplicationId, isNew)
    },
    create() {
      // Create the tmp app
      var tmpDealerApp = {
        name: this.dealerName,
        doingBusinessAs: this.doingBusinessAs,
        programId: this.$store.getters.getProgram.id,
        status: 0,
        exclusiveBankId: this.$store.getters.getSelectedExclusiveLender,
        annualSalesAmount:  0, //currency component has issues with null
        annualFinancingAmount: 0,
        avgTicketAmount: 0
      }

      axiosAuthInstance
        .post('api/v1/dealerApp/create', tmpDealerApp)
        .then(response => {
          var newAppId = response.data.id
          this.selectApplication(newAppId, true)
        })
        .catch(error => {
          this.notifyAxiosError(
            error,
            'There was an error during application creation'
          )
        })
    },
    getApplicationList() {
      this.loading = true
      // On Mounted grab the most recent list of applications
      axiosAuthInstance
        .get('api/v1/dealerApp/list/' + this.$store.getters.getProgram.id)
        .then(response => {
          //if applications are returned set them
          if (response.data && response.data.length > 0) {
            this.applications = response.data
          }
        })
        .catch(error => {
          if (error.response && error.response.status == '401') {
            this.$router.push({
              //avoid issue with showing an error page for reset pw issue
              path: '/login'
            })
          } else {
            this.notifyAxiosError(
              error,
              'There was an error listing your applications'
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    deleteApp(inApplication) {
      confirm('Are you sure you want to remove this Application?') &&
        axiosAuthInstance
          .delete('api/v1/dealerApp/' + inApplication.id)
          .then(response => {
            const index = this.applications.indexOf(inApplication)
            this.applications.splice(index, 1)

            this.getApplicationList()
          })
          .catch(error => {
            console.log(
              'There was an error on deletion of application: ' + error
            )
          })
    },
    close() {
      this.$refs.newAppForm.reset()
      this.dealerName = ''
      this.doingBusinessAs = ''
      this.dialog = false
    },

    fetchAppAndRoute(applicationId, isNew) {
      axiosAuthInstance
        .get('api/v1/dealerApp/getStatus/' + applicationId)
        .then(response => {
            this.fetchAvailableLenders(this.$store.getters.getSelectedExclusiveLender).then(response2 => {
              if (this.$store.getters.getAvailableLenders.length > 1) {
                if (response.data >= APP_STATUSES.SUBMITTED) {
                  this.$router.push('/submittedApplication')
                } else if (isNew) {
                  this.$router.push({
                    path: '/lender-selection',
                    query: {isNewApp: true}
                  })
                } else {
                  this.$router.push('/application')
                }
              } else {
                if (response.data >= APP_STATUSES.SUBMITTED) {
                  this.$router.push('/submittedApplication')
                } else {
                  this.$router.push('/application')
                }
              }
            })
        })
        .catch(error => {
          this.notifyAxiosError(
            error,
            'There was an error retrieving the application status'
          )
        })
    },
    hasLenderStatus(app) {
      if(!app || app.lenders.length < 1) {
        return false
      }

      let hasStatus = false;
      app.lenders.forEach(lender => {
          if(lender.lenderStatus) {
            hasStatus = true
          }
        })

      return hasStatus;
    }
  },
  created() {
    this.authenticatedUser = this.$store.getters.getAuthenticatedUser
  },
  mounted() {
    this.getApplicationList()

    this.$store.commit('resetApplication')
  }
}
</script>
<style lang="scss" scoped>
.headline {
  text-align: center;
  justify-content: center;
}
.remove-padding {
  padding: 0 !important;
}
.intro {
  p {
    margin: 1rem;
    font-size: 1.25rem;
  }
  ul {
    margin: 1rem;
    font-size: 1rem;
    li {
      list-style-type: circle;
      margin: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ApplicationList.vue